export const CarouselActionType = {
  LIST_CAROUSEL: "LIST_CAROUSEL",
};
